import { CircularProgress } from '@mui/material';

interface IProps {
	size?: number;
	value: number;
}

export default function ECircualrProgress({ size = 40, value }: IProps) {
	return (
		<div style={{ width: size, height: size }} className="center rounded-full bg-action-active bg-opacity-55 p-0.5">
			<CircularProgress size={size - 4} variant="determinate" value={value} />
		</div>
	);
}
